// extracted by mini-css-extract-plugin
module.exports = {"trigger":"group_trigger__fu4aS"};